export type RingStyle = Pick<
  google.maps.CircleOptions,
  'fillColor' | 'fillOpacity' | 'strokeColor' | 'strokeOpacity' | 'strokeWeight'
>;

export const CLASSIC_RING_COLOR = '#435674';
export const CLASSIC_RING_FALLBACK_COLOR = '#3B82F6';

export const classicRingOpacity = (index: number) => Math.max(0.1, 0.35 - (index * 0.08));

export const classicRingStyle = (color = CLASSIC_RING_COLOR) => (index: number): RingStyle => ({
  fillColor: color || CLASSIC_RING_FALLBACK_COLOR,
  fillOpacity: classicRingOpacity(index),
  strokeColor: color,
  strokeOpacity: 0.8,
  strokeWeight: 1
});

// The Buildout OS prototype's ring blue. Hex rather than a Blueprint token: Google Maps needs a literal
// colour, and the nearest token (buildout-blue-600) isn't exposed as a CSS variable at runtime.
const OS_RING_COLOR = '#2563eb';
// Smallest ring to largest, so the rings stack darkest at the centre.
const OS_RING_FILL_OPACITIES = [0.2, 0.13, 0.06];

export const osRingStyle = (_index: number, sizeRank: number): RingStyle => ({
  fillColor: OS_RING_COLOR,
  fillOpacity: OS_RING_FILL_OPACITIES[Math.min(sizeRank, OS_RING_FILL_OPACITIES.length - 1)],
  strokeColor: OS_RING_COLOR,
  strokeOpacity: 1,
  strokeWeight: 1.5
});

// The prototype's teardrop pin: a square with one sharp corner, turned so that corner points down.
// The marker anchors the element's bottom edge on the property, and the rotated corner of the 18px
// (border-box) square reaches ~3.7px below that edge, so the lift puts its tip on the point.
export const buildOsPin = () => {
  const pin = document.createElement('span');
  Object.assign(pin.style, {
    display: 'block',
    width: '18px',
    height: '18px',
    backgroundColor: OS_RING_COLOR,
    border: '2px solid #fff',
    borderRadius: '50% 50% 50% 0',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.4)',
    transform: 'translateY(-3.7px) rotate(-45deg)'
  });
  return pin;
};
